
import styles from "../AccountingPage.module.scss";
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import Notification from "utils/Notifications";
import { Button } from 'components'
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";

import { getAcademicYearsData, getBranchesData, getEducationTypesData, getDepartmentsData, getSpecialitiesData, getContractAmountsData, getCoursesData, postContractAmountsData } from "service/AccountingService";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import { Icon } from '../../../components/UnvUI/Icons'


const ContractAmountContent = ({ render, setRender, id }) => {
  const { t } = useTranslation('common')

  const componentRef = useRef();


  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });


  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [data, setData] = useState([]);
  const getData = async (id) => {

  };
  const [academicyears, setAcademicYears] = useState([]);
  const getAcademicYears = async (id) => {
    try {
      let response = await getAcademicYearsData(id, academicyears);
      setAcademicYears(response.data);

    } catch (error) {
    }
  };
  const [branches, setBranches] = useState([]);
  const getBranches = async (id) => {
    try {
      let response = await getBranchesData(id, branches);
      setBranches(response.data);

    } catch (error) {
    }
  };

  const [educationtypes, setEducationTypes] = useState([]);
  const getEducationTypes = async (id) => {
    try {
      let response = await getEducationTypesData(id, educationtypes);
      setEducationTypes(response.data);

    } catch (error) {
    }
  };

  const [departments, setDepartments] = useState([]);
  const getDepartments = async (id) => {
    try {
      let response = await getDepartmentsData(id, departments);
      setDepartments(response.data);

    } catch (error) {
    }
  };

  const [specialities, setSpecialities] = useState([]);
  const getSpecialities = async (id) => {
    try {
      let response = await getSpecialitiesData(id, departments);
      setSpecialities(response.data);

    } catch (error) {
    }
  };

  const [courses, setCourses] = useState([]);
  const getCourses = async (id) => {
    try {
      let response = await getCoursesData(id, courses);
      setCourses(response.data);

    } catch (error) {
    }
  };


  const [academicYearID, setAcademicYearID] = useState("");
  const [branchID, setBranchID] = useState("");
  const [departmentID, setDepartmentID] = useState("");
  const [educationTypeID, setEducationTypeID] = useState("");

  const handleSelectAcademicYear = (id) => {
    setAcademicYearID(id);
  };
  const handleSelectBranch = (id) => {
    setBranchID(id);
    getDepartments(id)
  };
  const handleSelectDepartment = (id) => {
    setDepartmentID(id);
  };
  const handleSelectEducationType = (id) => {
    setEducationTypeID(id);
  };


  const [contractamounts, setContractAmounts] = useState([]);
  const getContractAmounts = async (departmentId, yearId, typeId) => {
    try {
      const response = await getContractAmountsData(yearId, departmentId, typeId);
      setContractAmounts(response.data);
    } catch (error) {
    }
  };


  useEffect(() => {
    if (academicYearID && branchID && departmentID && educationTypeID) {
      getSpecialities(departmentID);
      getContractAmounts(departmentID, academicYearID, educationTypeID);
    }
  }, [academicYearID, branchID, departmentID, educationTypeID]);


  useEffect(() => {

    getAcademicYears(id);
    getBranches(id);
    getCourses(id);
    getEducationTypes(id);
    setRender(false);


  }, [render]);


  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const totalPages = Math.ceil(specialities.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = specialities.slice(indexOfFirstItem, indexOfLastItem);


  const [editedAmounts, setEditedAmounts] = useState({});
  const handleAmountChange = (specialityId, courseId, value) => {
    setEditedAmounts((prev) => ({
      ...prev,
      [specialityId]: {
        ...prev[specialityId],
        [courseId]: value,
      },
    }));
  };
  const [editRowId, setEditRowId_Set] = useState(null);


  const setEditRowId = (item) => {
    const specialityId = item.id;

    const initialAmounts = {};

    courses.forEach((course) => {
      const match = contractamounts.find(
        (contract) =>
          contract.speciality === specialityId &&
          contract.course === course.id
      );
      initialAmounts[course.id] = match ? match.amount.toString() : "0";
    });

    setEditedAmounts((prev) => ({
      ...prev,
      [specialityId]: initialAmounts,
    }));

    setEditRowId_Set(specialityId);
  };
  const onSave = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    const rowsData = [];
    for (const [specialityId, courses] of Object.entries(editedAmounts)) {
      for (const [courseId, value] of Object.entries(courses)) {
        rowsData.push({
          academic_year: academicYearID,
          education_type: educationTypeID,
          speciality: Number(specialityId),
          course: Number(courseId),
          amount: Number(value) || 0,
        });
      }
    }

    formData.append('contracts', JSON.stringify(rowsData));
    try {
      const response = await postContractAmountsData(formData); 
      setNotify({
        isOpen: true,
        message: "Данные успешно отправлены!",
        type: "success",
      });


      setEditRowId_Set(null);
      getContractAmounts(departmentID, academicYearID, educationTypeID);
      setRender(true)
    } catch (error) {
      setNotify({
        isOpen: true,
        message: "Ошибка при отправке данных!",
        type: "error",
      });
    }

  };


  return (
    <>

      <div className={styles.content_header}>
        <div className={styles.content_header_in}>

          <h2 className={styles.project__h}>{t('auto.components_contractamountcontent.k1')}</h2>
        </div>
        <button className={styles.btn_print} onClick={handlePrint}>{t('auto.components_academicyearcontent.k1')} </button>

      </div>

      <div className={styles.div_search}>
        <h2 className={styles.project__h}>{t('auto.components_contractamountcontent.k2')}</h2>
        <div className={styles.div_check_search_two}>
          <div>
            <label>{t('auto.components_contractamountcontent.k3')}</label>
            <select
              value={academicYearID}
              onChange={(e) => handleSelectAcademicYear(e.target.value)}
            >
              <option value="">{t('auto.components_contractamountcontent.k4')}</option>
              {Array.isArray(academicyears) && academicyears.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label>{t('auto.components_contractamountcontent.k5')}</label>
            <select
              value={branchID}
              onChange={(e) => handleSelectBranch(e.target.value)}
            >
              <option value="">{t('auto.components_contractamountcontent.k6')}</option>
              {Array.isArray(branches) && branches.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label>{t('auto.components_contractamountcontent.k7')}</label>
            <select
              value={departmentID}
              onChange={(e) => handleSelectDepartment(e.target.value)}
            >
              <option value="">{t('auto.components_contractamountcontent.k8')}</option>
              {Array.isArray(departments) && departments.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label>{t('auto.components_contractamountcontent.k9')}</label>
            <select
              value={educationTypeID}
              onChange={(e) => handleSelectEducationType(e.target.value)}
            >
              <option value="">{t('auto.components_contractamountcontent.k10')}</option>
              {Array.isArray(educationtypes) && educationtypes.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
        </div>


      </div>

      <table ref={componentRef} className={styles.table__wrapper}>
        <thead className={styles.table__head}>
          <tr className={styles.table__row}>
            <th className={styles.table__item_contract}>№</th>

            <th className={styles.table__item_contract}>
              <span className={styles.table__title}>{t('archive.col_specialty')}</span>
            </th>

            {courses.map((itemcourse, index) => (

              <th className={styles.table__item_contract} key={itemcourse.id}>
                <span className={styles.table__title}>{itemcourse.name} курс</span>
              </th>
            ))}
            <th className={styles.table__item__nav} >
              <span className={styles.table__title}>{t('common.actions')}</span>
            </th>
          </tr>
        </thead>

        <tbody className={styles.table__body}>
          {currentItems.map((item, index) => (

            <tr className={styles.table__row} key={item.id}>
              <td className={styles.table__item_contract}>
                <span className={styles.table__title}>
                  {index + 1 + (currentPage - 1) * itemsPerPage}
                </span>
              </td>
              {editRowId === item.id ? (
                <>
                  <td className={styles.table__item_contract}>{item.name}</td>
                  {courses.map((itemcourse) => (
                    <td className={styles.table__item_contract} key={itemcourse.id}>

                      <input
                        className={styles.edit_input}
                        type="number"
                        value={editedAmounts[item.id]?.[itemcourse.id] || ""}
                        onChange={(e) =>
                          handleAmountChange(item.id, itemcourse.id, e.target.value)
                        }
                      />
                    </td>
                  ))}

                  <td className={styles.table__item__nav} >
                    <div className={styles.table__item__div}>
                      <button onClick={onSave} className={styles.saveBtn}><Icon name="save" /> </button>
                      <button onClick={() => setEditRowId_Set(null)} className={styles.cancelBtn}>
                        <Icon name="close" />
                      </button>
                    </div>
                  </td>

                </>
              ) : (
                <>
                  <td className={styles.table__item_contract}>
                    <span className={styles.table__title} style={{ fontWeight: '700' }}>
                      {item.name}
                    </span>
                  </td>

                  {courses.map((itemcourse) => {
                    const match = contractamounts.find(
                      (contract) =>
                        contract.speciality === item.id &&
                        contract.course === itemcourse.id
                    );

                    return (
                      <td className={styles.table__item_contract} key={itemcourse.id}>
                        <span className={styles.table__title}>
                          {match ? match.amount : "не указан"}
                        </span>
                      </td>
                    );
                  })}
                  <td className={styles.table__item_contract}>
                    <div className={styles.table__item__div}>
                      <button onClick={() => setEditRowId(item)} className={styles.editBtn}><Icon name="edit" /> </button>

                    </div>
                  </td>
                </>
              )}
            </tr>
          ))}

          

        </tbody>
        <div className={styles.pagination}>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => setCurrentPage(page)}
              style={{
                padding: '5px 10px',
                background: currentPage === page ? '#736CED' : '#f0f0f0',
                color: currentPage === page ? '#fff' : '#000',
                border: '1px solid #ccc',
                borderRadius: "6px",
                cursor: 'pointer',
              }}
            >
              {page}
            </button>
          ))}
        </div>


      </table>


      <Notification notify={notify} setNotify={setNotify} />


    </>


  );
};

export default ContractAmountContent;
